<template>
    <div>
        <b-jumbotron bg-variant="light" border-variant="light" style="padding: 2rem 1rem;">
            <template v-slot:header>Random openinG</template>

            <template v-slot:lead>Escucha openings aleatorios... o busca tu favorito!</template>
        </b-jumbotron>

        <div>
            <div class="row">
                <div class="col-md-10 offset-md-1">
                    <iframe src="https://openings.moe" width="100%" height="550"
                            allowtransparency="yes" allow="autoplay" frameborder="1" marginheight="0" marginwidth="0"
                            scrolling="auto"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Openings"
    }
</script>

<style scoped>

</style>